import React from 'react'
import MailchimpSignup from '../shared/MailchimpSignup'
import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'

interface ChallengeSubmissionExpiredProps {
	space: any
	subject: any
}

const ChallengeSubmissionExpired = ({
	space,
	subject,
}: ChallengeSubmissionExpiredProps) => {
	return (
		<div className="bg-purple-900 rounded-lg shadow">
			<h2 className="text-2xl text-white mb-3 font-sans font-bold px-8 pt-8">
				Challenge submission expired
			</h2>
			<p className="mb-4 px-8 pb-4 text-lg text-white opacity-80">
				You can&apos;t submit new challenges for this space. Leave your details
				below and we will let you know when this space starts again.
			</p>

			<MailchimpSignup
				spaceTitle={space.attributes.title}
				spaceSubject={subject?.attributes?.title}
				containerClass="flex flex-wrap items-end justify-start px-8"
				submitButtonClass="button bg-yellow-400 text-black hover:bg-yellow-500"
			/>

			<div className="border-t border-purple-800 mt-8 flex items-center justify-start flex-wrap px-8 py-4">
				<h4 className="text-white font-semibold my-2 text-lg mr-4">
					Don&apos;t miss out on the rest?
				</h4>
				<Link href="/challenge-spaces" passHref>
					<button
						type="button"
						className="bg-white my-2 text-black hover:bg-gray-100 duration-300 transition-colors"
					>
						Explore other spaces
						<FontAwesomeIcon icon={faChevronRight} size="xs" className="ml-3" />
					</button>
				</Link>
			</div>
		</div>
	)
}

export default ChallengeSubmissionExpired
